import React from 'react'
import { func } from 'prop-types'
import { DWSections, SecondaryHeader } from '../../components'
import { dataPlatformSections, privacySections } from '../../config'

const PRIVACY_LINK_INDEX = 2

const DWSubHeader = ({ onSectionClick }) => (
  <SecondaryHeader
    selectedTabId="privacyLink"
    selectedTabIndex={PRIVACY_LINK_INDEX}
  >
    <div id="dw-privacy-link">
      <DWSections sections={privacySections} onSectionClick={onSectionClick} />
      <DWSections
        sections={dataPlatformSections}
        onSectionClick={onSectionClick}
      />
    </div>
  </SecondaryHeader>
)

DWSubHeader.propTypes = {
  onSectionClick: func.isRequired,
}

export default DWSubHeader
